// src/components/WhyChooseUs.js
import React, { useState, useEffect } from 'react';
import './WhyChooseUs.css';

// Import FontAwesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUsers,
  faShieldAlt,
  faClock,
  faMoneyBillWave,
  faCheckCircle,
  faFileInvoice,
  faHandshake
} from '@fortawesome/free-solid-svg-icons';

function WhyChooseUs() {
  const [headerAnimated, setHeaderAnimated] = useState(false);
  const [gridAnimated, setGridAnimated] = useState(false);
  const [ctaAnimated, setCtaAnimated] = useState(false);

  useEffect(() => {
    const elementsToAnimate = [
      { selector: '.why-choose-section .section-header', setState: setHeaderAnimated, animatedState: headerAnimated, threshold: 0.85 },
      { selector: '.why-choose-section .benefits-grid', setState: setGridAnimated, animatedState: gridAnimated, threshold: 0.60 }, // Triggers a bit earlier for the grid
      { selector: '.why-choose-section .choose-us-cta', setState: setCtaAnimated, animatedState: ctaAnimated, threshold: 0.85 }
    ];

    const handleScroll = () => {
      elementsToAnimate.forEach(item => {
        if (!item.animatedState) {
          const element = document.querySelector(item.selector);
          if (element) {
            const position = element.getBoundingClientRect();
            // Check if the top of the element is within the viewport or slightly below
            if (position.top < window.innerHeight * item.threshold && position.bottom >= 0) {
              item.setState(true);
            }
          }
        }
      });
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll(); // Initial check in case elements are already in view

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [headerAnimated, gridAnimated, ctaAnimated]);

  const benefits = [
    { icon: faUsers, title: 'Qualified Experts', text: 'Our team consists of fully trained and experienced roofing professionals.', delay: '0.1s' },
    { icon: faShieldAlt, title: 'Guaranteed Work', text: 'All our roofing services come with a comprehensive workmanship warranty.', delay: '0.2s' },
    { icon: faClock, title: 'No Call-Out Fees', text: 'We provide free consultations and never charge call-out fees.', delay: '0.3s' },
    { icon: faMoneyBillWave, title: 'Competitive Pricing', text: 'Fair and transparent pricing with no hidden costs or surprises.', delay: '0.4s' },
    { icon: faCheckCircle, title: 'Free Surveys', text: 'Thorough roof inspections and detailed assessments at no cost.', delay: '0.5s' },
    { icon: faFileInvoice, title: 'No Obligation', text: 'Receive a comprehensive quotation with absolutely no pressure to commit.', delay: '0.6s' }
  ];

  return (
    <section className="why-choose-section">
      <div className="container">
        <div className={`section-header ${headerAnimated ? 'animated' : ''}`}>
          <h2 className="section-title">WHY WE ARE THE #1 CHOICE</h2>
          <p className="section-description">
            Benefit from a skilled workforce with a track record of integrity and professionalism.
          </p>
        </div>

        <div className={`benefits-grid ${gridAnimated ? 'animated' : ''}`}>
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="benefit-card" // Animation will be controlled by parent .benefits-grid.animated
              style={{ animationDelay: benefit.delay }} // Still useful for staggered effect if CSS supports it
            >
              <div className="benefit-icon">
                <FontAwesomeIcon icon={benefit.icon} />
              </div>
              <h3 className="benefit-title">{benefit.title}</h3>
              <p className="benefit-text">{benefit.text}</p>
            </div>
          ))}
        </div>

        <div className={`choose-us-cta ${ctaAnimated ? 'animated' : ''}`}>
          <div className="trust-badge">
            <div className="trust-icon">
              <FontAwesomeIcon icon={faHandshake} />
            </div>
            <div className="trust-content">
              <h3>Experience the Old Glossop Roofing Difference</h3>
              <p>Quality craftsmanship and exceptional customer service.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default WhyChooseUs;